import { Typography } from "@suraasa/placebo-ui"

interface ViolationSummaryCardProps {
  totalViolations: number
}
const ViolationSummaryCard = ({
  totalViolations,
}: ViolationSummaryCardProps) => {
  return (
    <div className="flex flex-wrap  items-center gap-2 rounded-xl bg-critical-600 p-2.5 text-white">
      <div className="flex size-fit items-center justify-center rounded-[40px] bg-white px-1.5 py-1">
        <span className="bg-white text-2xl font-bold text-critical-600">
          {totalViolations}
        </span>
      </div>
      <Typography
        variant={"strong"}
        className="max-w-20 text-[16px] font-bold md:text-[20px] md:font-semibold"
      >
        Total Violations Detected
      </Typography>
    </div>
  )
}
export default ViolationSummaryCard
